import { render, staticRenderFns } from "./SubprocessNode.vue?vue&type=template&id=bda64dee"
import script from "./SubprocessNode.vue?vue&type=script&lang=js"
export * from "./SubprocessNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports